{
  "title": "Heroism",
  "source": "Player's Handbook",
  "levelAndSchool": "1st-level enchantment",
  "level": 1,
  "castingTime": "1 action",
  "range": "Touch",
  "components": "V, S",
  "duration": "Concentration, up to 1 minute",
  "description": [
    "A willing creature you touch is imbued with bravery. Until the spell ends, the creature is immune to being frightened and gains temporary hit points equal to your spellcasting ability modifier at the start of each of its turns. When the spell ends, the target loses any remaining temporary hit points from this spell.",
    "At Higher Levels. When you cast this spell using a spell slot of 2nd level or higher, you can target one additional creature for each slot level above 1st."
  ],
  "spellLists": ["bard", "paladin"]
}
